// src/context/ReclamoModalContext.jsx
import React, { createContext, useCallback, useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import ReclamoModal from "../modules/reclamos/components/ReclamoModal";

const ReclamoModalContext = createContext(null);

export function ReclamoModalProvider({ children }) {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [title, setTitle] = useState("");       // la placa (título del modal)
  const [extra, setExtra] = useState(null);     // datos opcionales: { placa, modem, ... }

  const openReclamo = useCallback((placa, initialData = null) => {
    setTitle(placa || "");
    setExtra(initialData || (placa ? { placa } : null));
    setOpen(true);
  }, []);

  const closeReclamo = useCallback(() => setOpen(false), []);

  const onSuccessNavigate = useCallback((id) => {
    setOpen(false);
    if (id) navigate(`/reclamos/${id}`);
  }, [navigate]);

  return (
    <ReclamoModalContext.Provider value={{ openReclamo }}>
      {children}
      <ReclamoModal
        open={open}
        onClose={closeReclamo}
        onSuccessNavigate={onSuccessNavigate}
        initialTitle={title}     // ← la placa como título
        initialData={extra}      // ← { placa: "XXXX-YYY" }
      />
    </ReclamoModalContext.Provider>
  );
}

export function useReclamoModal() {
  const ctx = useContext(ReclamoModalContext);
  if (!ctx) throw new Error("useReclamoModal debe usarse dentro de ReclamoModalProvider");
  return ctx;
}
